import type { IntlShape } from 'react-intl';

import type { User } from 'src/apiClients/queries';

import { i18n } from './get-access-level-label.i18n';

export const getAccessLevelLabel = (user: User | null | undefined, intl: IntlShape): string => {
    if (!user) return '';

    const { hasEntitlementsRole, hasSupportRole, isAdminReadOnly } = user;

    if (hasEntitlementsRole && hasSupportRole) {
        return intl.formatMessage(isAdminReadOnly ? i18n.fullReadOnly : i18n.full);
    }
    if (hasEntitlementsRole) {
        return intl.formatMessage(
            isAdminReadOnly ? i18n.licensingReadOnly : i18n.licensingEntitlements,
        );
    }
    if (hasSupportRole) {
        return intl.formatMessage(
            isAdminReadOnly ? i18n.supportReadOnly : i18n.supportEntitlements,
        );
    }
    if (isAdminReadOnly) {
        return intl.formatMessage(i18n.readOnly);
    }
    return '';
};
